
import { computed, defineComponent } from 'vue'
import FooterNav from './FooterNav/index.vue'
import HeadNav from './HeadNav/index.vue'
import Breadcrumb from './Breadcrumb/index.vue'
import { useRoute } from 'vue-router'
import type { RouteLocationNormalizedLoaded } from 'vue-router'

export default defineComponent({
  components: {
    FooterNav,
    HeadNav,
    Breadcrumb
  },
  setup() {
    const route: RouteLocationNormalizedLoaded = useRoute()
    const meetingName = computed(() => {
      return (route.query.meetingName as string) || ''
    })
    return {
      meetingName
    }
  }
})
